import React from 'react';
import {Accordion} from '../../Accordion/Accordion';
import {ContentWrapper} from './FileMetaDataTabImage.style';
import {t} from 'i18next';
import {generateIdentifier} from '../../../utils/IdentityUtils';
import EventEmitter from 'events';
import {UploadImageComponent} from '../../UploadImageComponent/UploadImageComponent';
import {FileMetaDataDialog_changeImage} from '../../../init/events';

export interface FileMetaDataTabImageProps {
    readonly thumbnailFile: File | null;
    readonly eventEmitter: EventEmitter;
}

/**
 * @name FileMetaDataTabImage
 * @description
 * The dialog to add the metadata of a newly created file or edited file - Metadata Tabs
 */
export const FileMetaDataTabImage: React.VFC<FileMetaDataTabImageProps> = (props) => {
    const handleImage = (imageFile: File | null) => {
        props.eventEmitter.emit(FileMetaDataDialog_changeImage, imageFile);
    };

    return (
        <ContentWrapper id={generateIdentifier()}>
            <Accordion accordionHeadline={t('UPLOAD_FILE_META_DATA_DIALOG_ACCORDION_TITLE_IMAGE')}
                       startOpen>
                <UploadImageComponent existingImage={props.thumbnailFile}
                                      onChange={handleImage}/>
            </Accordion>
        </ContentWrapper>
    );
}